import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { GatewayState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';
import { translator } from '../../translator';
import { AppContext } from '../../context';
const MessageKey = AppContext.MessageKey;

export const actions: ActionTree<GatewayState, RootState> = {
    /**
     * ゲートウェイの環境変数取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async gatewaySettings({ dispatch, commit }) {
        try {
            commit(types.SETTING_SHOW_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.User.GATEWAY_SETTING },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SETTING_SHOW_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SETTING_SHOW_FAILURE, resData.errors[0]);
        }
    },

    /**
     * SSH接続用URL取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async sshConnectUrl({ dispatch, commit }) {
        try {
            commit(types.SSH_CONNECT_START);
            const resData = await dispatch('auth/api', { method: 'get', url: ApiUrl.User.SSH_CONNECT }, { root: true });
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SSH_CONNECT_SUCCESS, resData['ssh_url']);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SSH_CONNECT_FAILURE, resData.errors[0]);
        }
    },

    /**
     * RDPファイルダウンロード処理開始
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async rdpFileDownloadStart({ commit }) {
        commit(types.RDP_FILE_DOWNLOAD_START);
    },

    /**
     * RDPファイルダウンロード処理正常終了
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async rdpFileDownloadSuccess({ commit }) {
        commit(types.RDP_FILE_DOWNLOAD_SUCCESS);
    },

    /**
     * RDPファイルダウンロード処理エラー終了
     * @param {any} commit Vuex変数
     * @param resData エラーレスポンス
     * @returns {Promise<void>}
     */
    async rdpFileDownloadFailure({ commit }, resData) {
        commit(types.RDP_FILE_DOWNLOAD_FAILURE, resData.errors[0]);
    },

    /**
     * セッショントークン取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async sessionToken({ dispatch, commit, rootState }) {
        try {
            commit(types.SESSION_TOKEN_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.User.SESSION_TOKEN },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SESSION_TOKEN_SUCCESS, resData.token);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.User.SESSION_TOKEN);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SESSION_TOKEN_FAILURE, resData.errors[0]);
        }
    },

    /**
     * エラーを消す
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async dealError({ commit }) {
        commit(types.ERROR_RESET);
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
